import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SubscriptionRequestsService {
  token = localStorage.getItem('token');
  options = {
    headers: new HttpHeaders({
      // tslint:disable-next-line:object-literal-key-quotes
      'Authorization': `Bearer ${this.token}`
    })
  };
  constructor(private http: HttpClient) { }

  getAllSubscribtionRequests(pagination, pageSize, pageNumber) {
    return this.http.get(environment.url + `v2/bus/schools/${localStorage.getItem('schoolId')}/bus-subscription-requests/paginate?&per_page=${pageSize}&page=${pageNumber}`)
  }

  approveSubscribtionRequest(requestId) {
    return this.http.post(environment.url + `v2/bus/schools/${localStorage.getItem('schoolId')}/bus-subscription-requests/${requestId}/approve`,null)
  }

  declineSubscribtionRequest(requestId) {
    return this.http.post(environment.url + `v2/bus/schools/${localStorage.getItem('schoolId')}/bus-subscription-requests/${requestId}/decline`,null)
  }
}
